module.exports = __webpack_public_path__ + "media/categories/1111-9ecc7ea1.svg";